import { LogoutOutlined } from '@mui/icons-material';
import { Button } from '@mui/material';

import { useAuth } from '@/contexts/AuthContext';
import { useTheme } from '@/theme';

function LogoutButton() {
  const theme = useTheme();
  const { logout, isAuthenticated } = useAuth();

  const handleLogoutClick = async () => {
    try {
      if (isAuthenticated) {
        await logout();
      }
    } catch (err) {
      console.error(`Logout was not possible: ${err}. Please try again.`);
    }
  };

  return (
    <Button
      aria-label='logout-button'
      data-testid='logout-button'
      variant='outlined'
      size='medium'
      onClick={handleLogoutClick}
      sx={{
        height: 36,
        padding: '4px',
        minWidth: '32px',
        color: theme.hhglobal.purpose.textWeak,
      }}
    >
      <LogoutOutlined />
    </Button>
  );
}

export default LogoutButton;
